import React from "react";
import clsx from "clsx";
// Hooks
import { useLocation as useRouterLocation } from "react-router-dom";
// MUI
import { Box, Button, Skeleton, Stack } from "@mui/material";
// Icons
import GeolocationIcon from "@/assets/icons/header/GeolocationIcon";
import SelectorChevron from "@/assets/icons/header/SelectorChevron";
import Global from "@/assets/icons/header/Global";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const checkIsGlobal = (pathname: string) => {
	const globalPages = ["/user-access-settings", "/group-settings", "/users"];
	return globalPages.includes(pathname);
};

interface ILocationSelectorButtonProps {
	open?: boolean;
	handleClick?: React.MouseEventHandler<HTMLButtonElement>;
	disabled: boolean;
	actionable: boolean;
	label?: string;
}

export const LocationSelectorButton: React.FC<Readonly<ILocationSelectorButtonProps>> = ({
	disabled,
	handleClick,
	actionable,
	open,
	label = "",
}) => {
	const router = useRouterLocation();
	const isGlobal = checkIsGlobal(router.pathname);
	const { loading } = useSelector((state: RootState) => state.location);
	const smartLabel = loading ? <Skeleton variant="text" width={150} className="!bg-[#FFFFFF66]" /> : label;
	const shouldShowChevron = !loading && !isGlobal && actionable;

	return (
		<Stack direction={"row"} height={"100%"} alignItems={"center"} spacing={1}>
			<Button
				id="select-box-button"
				aria-controls="select-box-menu"
				aria-haspopup="true"
				disableRipple
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				disabled={disabled || isGlobal}
				className={clsx("hover:drop-shadow-subtle-white group !text-white !capitalize", {
					"opacity-50": disabled,
				})}
			>
				<Box className="flex items-center">
					{isGlobal ? <Global /> : <GeolocationIcon />}
					<Box className="font-normal font-sans text-[16px]/[20.7px] ml-3 underline-offset-[1.8px] group-hover:underline text-nowrap text-ellipsis max-w-60 overflow-hidden">
						<span className="text-ellipsis">{isGlobal ? "Global" : smartLabel}</span>
					</Box>
					{shouldShowChevron && (
						<SelectorChevron
							className={clsx("ml-[2.49px]", {
								"rotate-180": open,
							})}
						/>
					)}
				</Box>
			</Button>
		</Stack>
	);
};
